import React from 'react';
import { Building2 } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

/**
 * ValoramapScoreBasisBadge — Indicateur visuel pour valoramap_score_basis
 *
 * Référence : METHODOLOGY v1.4 §4.6.3 et §4.7.1
 *
 * Trois cas selon basis :
 *  - "full"               : pas d'indicateur (cas nominal, render null)
 *  - "reduced_financial"  : icône Building2 grise + tooltip explicatif
 *  - "no_data"            : badge "Données en attente" (#FEF3C7 / #92400E)
 *  - autre / null         : null (pas d'indicateur, graceful degradation)
 *
 * Props :
 *  - basis: "full" | "reduced_financial" | "no_data" | null | undefined
 *  - className: classes additionnelles (optionnel)
 */
const ValoramapScoreBasisBadge = ({ basis, className = '' }) => {
  if (!basis || basis === 'full') {
    return null;
  }

  if (basis === 'reduced_financial') {
    return (
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className={`inline-flex items-center cursor-help ${className}`}
              data-testid="basis-reduced-financial"
              aria-label="Score calculé sur base réduite (financière)"
            >
              <Building2 className="w-4 h-4 text-gray-400" />
            </span>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className="max-w-[320px] bg-[#1a1a2e] border-white/20 text-gray-200 text-xs p-3 z-50"
          >
            <p>
              Score calculé sur 3 composantes (valorisation, catalyst, liquidité).
              Les scores académiques (Altman, Piotroski, Beneish) ne sont pas
              applicables aux entreprises financières.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  if (basis === 'no_data') {
    return (
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium cursor-help ${className}`}
              style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}
              data-testid="basis-no-data"
            >
              Données en attente
            </span>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className="max-w-[320px] bg-[#1a1a2e] border-white/20 text-gray-200 text-xs p-3 z-50"
          >
            <p>
              Données financières non disponibles. Intégration vnstock prévue.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  // Unknown basis value — graceful degradation
  return null;
};

export default ValoramapScoreBasisBadge;
